'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _riskAnalysis = require('./risk-analysis.component');

var _riskAnalysis2 = _interopRequireDefault(_riskAnalysis);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.adverseEvent.risk-analysis', []).component('riskAnalysis', _riskAnalysis2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/adverse-event/risk-analysis/risk-analysis.module.js